import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', short: 'EN', key: 'lang.en' },
  { code: 'pl', short: 'PL', key: 'lang.pl' },
  { code: 'es', short: 'ES', key: 'lang.es' },
  { code: 'fr', short: 'FR', key: 'lang.fr' },
];

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const changeLanguage = (code: string) => {
    i18n.changeLanguage(code);
    document.documentElement.lang = code;
    setOpen(false);
  };

  const current = languages.find((l) => l.code === i18n.language) || languages[0];

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
        aria-label={t('lang.label')}
      >
        <i className="ri-global-line text-foreground-600"></i>
        <span className="whitespace-nowrap">{current.short}</span>
        <i className={`ri-arrow-down-s-line text-xs transition-transform ${open ? 'rotate-180' : ''}`}></i>
      </button>
      {open && (
        <div className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-lg border border-background-200 bg-white">
          {languages.map((lang) => (
            <button
              key={lang.code}
              type="button"
              onClick={() => changeLanguage(lang.code)}
              className={`flex w-full items-center justify-between px-4 py-2.5 text-left text-sm transition-colors hover:bg-background-100 ${
                lang.code === i18n.language ? 'font-bold text-primary-700' : 'text-foreground-700'
              }`}
            >
              <span className="whitespace-nowrap">{t(lang.key)}</span>
              {lang.code === i18n.language && <i className="ri-check-line text-primary-600"></i>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}